export default "__VITE_ASSET__2c425f9f__"